import moment from 'moment';

const isoDateFormat = "YYYY-MM-DD";
const defaultRangeMonths = 6;

export function getDefaultDateRange() {
    return {
        startDate: moment().subtract(defaultRangeMonths, 'months').format(isoDateFormat),
        endDate: moment().format(isoDateFormat)
    };
}

export function isDateRangeValid(startDate, endDate) {
    if (startDate == null || endDate == null) {
        return false;
    }

    return !moment(endDate, isoDateFormat).isBefore(moment(startDate, isoDateFormat));
}
